<!--用于订单的多项展示-->
<template>
  <el-form label-position="left" inline class="table-expand-form">
    <!--      项目订单-->
    <div class="table-expand-form-order-part">
      <div class="table-expand-form-order-title">项目订单</div>
      <template v-for="(i, index) in data.column.expandFields">
        <el-form-item
          v-if="i.use == 1"
          class="table-expand-form-order-cell"
          :label="`${i.label}:`"
          :key="index"
          :prop="i.prop"
        >
          <div class="other-row">
            <template v-if="i.render">
              <myrender
                :row="data.row"
                :column="i"
                :index="index"
                :no="index"
                :render="i.render || null"
              />
            </template>
            <template v-else-if="i.formatter">
              {{ i.formatter(data.row, i) }}
            </template>
            <template v-else>
              {{ data.row[i.prop] }}
            </template>
          </div>
        </el-form-item>
      </template>
    </div>
    <!--      平台服务费订单-->
    <div
      class="table-expand-form-order-part"
      v-if="!(data.row || {})['newOrderId']"
    >
      <div class="table-expand-form-order-title">
        平台服务费订单
      </div>
      <template v-for="(i, index) in data.column.expandFields">
        <el-form-item
          v-if="i.use == 2"
          class="table-expand-form-order-cell"
          :label="`${i.label}:`"
          :key="index"
          :prop="i.prop"
        >
          <div class="other-row">
            <template v-if="i.render">
              <myrender
                :row="data.row"
                :column="i"
                :index="index"
                :no="index"
                :render="i.render || null"
              />
            </template>
            <template v-else-if="i.formatter">
              {{ i.formatter(data.row, i) }}
            </template>
            <template v-else>
              {{ data.row[i.prop] || '-' }}
            </template>
          </div>
        </el-form-item>
      </template>
    </div>
    <template v-for="(i, index) in data.column.expandFields">
      <el-form-item
        v-if="!i.use"
        class="table-expand-form-order-cell"
        :label="`${i.label}:`"
        :key="index"
        :prop="i.prop"
      >
        <div class="other-row">
          <template v-if="i.formatter">
            {{ i.formatter(data.row, i) || '-' }}
          </template>
          <template v-else>
            {{ data.row[i.prop] || '-' }}
          </template>
        </div>
      </el-form-item>
    </template>
  </el-form>
</template>

<script>
import myrender from './myrender';
export default {
  name: 'tableFormOrder',
  components: { myrender },
  inject: ['main'],
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  created() {}
};
</script>

<style lang="scss">
.table-expand-form {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .el-form {
    padding: 0;
  }
  &-order {
    &-part {
      display: flex;
      width: 100%;
      background: #fafafa;
      margin-bottom: 15px;
    }
    &-title {
      padding-left: 20px;
      flex: 0 0 15%;
      font-weight: 700;
      font-size: 14px;
      margin-bottom: 22px;
      line-height: 40px;
    }
    &-cell {
      flex: 0 0 17%;
      padding: 10px 0 10px;
      & > label {
        display: block;
        color: #b9b9b9;
      }
      .el-table__expanded-cell[class*='cell'] {
        padding: 10px 50px;
      }
      & > .el-form-item__content {
        line-height: 1;
        display: block;
      }
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}
</style>
